import axios from "axios";

const API = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
});

let brandingPromise;

const applyFavicon = (faviconUrl) => {
    if (!faviconUrl) return;
    let link = document.querySelector("link[rel*='icon']");
    if (!link) {
        link = document.createElement("link");
        link.rel = "icon";
        document.head.appendChild(link);
    }
    link.href = faviconUrl;
};

export const fetchBranding = async () => {
    if (!brandingPromise) {
        brandingPromise = API.get("/branding")
            .then((res) => res.data || {})
            .catch(() => ({}));
    }
    const branding = await brandingPromise;
    applyFavicon(branding.faviconUrl);
    return branding;
};
